const RML_FOLDER_DELETED = "RML/Folder/Deleted";
const RML_FOLDER_RENAMED = "RML/Folder/Renamed";
const RML_ATTACHMENT_MOVE_FINISHED = "RML/Attachment/MoveFinished";
export { RML_ATTACHMENT_MOVE_FINISHED, RML_FOLDER_DELETED, RML_FOLDER_RENAMED };
